import { render, staticRenderFns } from "./LocalVideo.vue?vue&type=template&id=2afb7932&scoped=true"
import script from "./LocalVideo.vue?vue&type=script&lang=js"
export * from "./LocalVideo.vue?vue&type=script&lang=js"
import style0 from "./LocalVideo.vue?vue&type=style&index=0&id=2afb7932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_13f162de80bf2e87404863986ae68eb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb7932",
  null
  
)

export default component.exports